import { JSX } from 'react'

import { IconProps } from '../../icon'

const Exam: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M33.6875 11.8125H30.8125V10.8125C30.8125 10.2947 30.3927 9.875 29.875 9.875H26.9019C26.5149 8.78369 25.4722 8 24.25 8C23.0278 8 21.9851 8.78369 21.5981 9.875H18.5625C18.0448 9.875 17.625 10.2947 17.625 10.8125V11.8125H14.8125C13.2617 11.8125 12 13.0742 12 14.625V37.1875C12 38.7383 13.2617 40 14.8125 40H33.6875C35.2383 40 36.5 38.7383 36.5 37.1875V14.625C36.5 13.0742 35.2383 11.8125 33.6875 11.8125ZM19.5 11.75H22.375C22.8927 11.75 23.3125 11.3303 23.3125 10.8125C23.3125 10.2956 23.7331 9.875 24.25 9.875C24.7669 9.875 25.1875 10.2956 25.1875 10.8125C25.1875 11.3303 25.6073 11.75 26.125 11.75H28.9375V12.75C28.9375 13.2669 28.5169 13.6875 28 13.6875H20.4375C19.9206 13.6875 19.5 13.2669 19.5 12.75V11.75ZM34.625 37.1875C34.625 37.7044 34.2044 38.125 33.6875 38.125H14.8125C14.2956 38.125 13.875 37.7044 13.875 37.1875V14.625C13.875 14.1081 14.2956 13.6875 14.8125 13.6875H17.7863C18.1733 14.7787 19.2153 15.5625 20.4375 15.5625H28C29.2222 15.5625 30.2643 14.7787 30.6513 13.6875H33.6875C34.2044 13.6875 34.625 14.1081 34.625 14.625V37.1875Z'
      fill='black'
    />
    <path
      d='M23.0433 24.2801C22.6803 23.911 22.0867 23.9061 21.7176 24.2692L18.568 27.3672L17.3504 26.1496C16.9843 25.7835 16.3907 25.7835 16.0246 26.1496C15.6585 26.5158 15.6585 27.1093 16.0246 27.4754L17.8997 29.3504C18.0826 29.5334 18.3225 29.625 18.5625 29.625C18.7999 29.625 19.0375 29.5354 19.2199 29.3559L23.0324 25.6059C23.4015 25.2428 23.4064 24.6492 23.0433 24.2801Z'
      fill='black'
    />
    <path
      d='M23.0433 30.8426C22.6803 30.4735 22.0867 30.4686 21.7176 30.8317L18.568 33.9297L17.3504 32.7121C16.9843 32.346 16.3907 32.346 16.0246 32.7121C15.6585 33.0783 15.6585 33.6718 16.0246 34.0379L17.8997 35.9129C18.0826 36.0959 18.3225 36.1875 18.5625 36.1875C18.7999 36.1875 19.0375 36.0979 19.2199 35.9184L23.0324 32.1684C23.4015 31.8053 23.4064 31.2117 23.0433 30.8426Z'
      fill='black'
    />
    <path
      d='M21.1005 21.4621L19.8883 20.25L21.1004 19.0379C21.4665 18.6718 21.4665 18.0782 21.1004 17.7121C20.7343 17.346 20.1407 17.346 19.7746 17.7121L18.5625 18.9242L17.3504 17.7121C16.9843 17.346 16.3907 17.346 16.0246 17.7121C15.6585 18.0782 15.6585 18.6718 16.0246 19.0379L17.2367 20.25L16.0247 21.4621C15.6585 21.8282 15.6585 22.4218 16.0247 22.7879C16.3907 23.154 16.9843 23.1541 17.3505 22.7879L18.5625 21.5758L19.7747 22.7879C20.1407 23.154 20.7343 23.1541 21.1005 22.7879C21.4666 22.4218 21.4666 21.8282 21.1005 21.4621Z'
      fill='black'
    />
    <path
      d='M31.8125 19.3125H26.125C25.6072 19.3125 25.1875 19.7322 25.1875 20.25C25.1875 20.7678 25.6072 21.1875 26.125 21.1875H31.8125C32.3302 21.1875 32.75 20.7678 32.75 20.25C32.75 19.7322 32.3302 19.3125 31.8125 19.3125Z'
      fill='black'
    />
    <path
      d='M31.8125 25.875H26.125C25.6072 25.875 25.1875 26.2947 25.1875 26.8125C25.1875 27.3303 25.6072 27.75 26.125 27.75H31.8125C32.3302 27.75 32.75 27.3303 32.75 26.8125C32.75 26.2947 32.3302 25.875 31.8125 25.875Z'
      fill='black'
    />
    <path
      d='M31.8125 32.4375H26.125C25.6072 32.4375 25.1875 32.8572 25.1875 33.375C25.1875 33.8928 25.6072 34.3125 26.125 34.3125H31.8125C32.3302 34.3125 32.75 33.8928 32.75 33.375C32.75 32.8572 32.3302 32.4375 31.8125 32.4375Z'
      fill='black'
    />
  </svg>
)

export default Exam
